import { Fragment, useState } from 'react';
import { Box, Typography, Modal, Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, FormControlLabel, Checkbox, Chip } from '@mui/material';
import { LoadingButton } from '@mui/lab'

import { useToaster } from '../../../../providers/ToasterProvider';

import RadiusButton from '../../../../components/RadiusButton';

import DOWNLOAD_BLUE from '../../../../assets/images/download-blue.svg';
import UPLOAD_GREY from '../../../../assets/images/upload-grey.svg';
import UPLOAD_WHITE from '../../../../assets/images/upload-white.svg';
import DELETE_ICON from '../../../../assets/images/action-delete.svg';
import { downloadCandidateTemplate } from '../../../../services/candidateService';
import mimes from '../../../../constant/mimes';
import { uploadProcessingCandidate } from '../../../../services/processingCandidateService';
import { uploadCandidate } from '../../../../services/masterService';

const columns = [
    { id: 'index', label: 'Row Number', minWidth: 140 },
    { id: 'rollNo', label: 'Roll No', minWidth: 140 },
    { id: 'userName', label: 'User Name', minWidth: 140 },
    { id: 'errors', label: 'Errors', minWidth: 190 },
];

export const UploadCandidateModal = ({ projectMasterId, uploadCandidateModalVisible, setUploadCandidateModalVisible, candidatesChanged, setCandidatesChanged, canEditLockedConfig = true }) => {

    const [candidateFile, setCandidateFile] = useState(null);
    const [photoFile, setPhotoFile] = useState(null);
    const [signFile, setSignFile] = useState(null);
    const [uploadResult, setUploadResult] = useState({
        isProcessed: false,
        createdRecordsCount: 0,
        errors: [],
        rps: { success: 0, failed: 0, errors: [] }
    });
    const { addNotification } = useToaster();
    const [isUploading, setIsUploading] = useState(false);
    const [uploadImages, setUploadImages] = useState(false);

    const handleFileChange = ({ target }) => {
        const file = target?.files[0];
        if (file && file?.type === 'text/csv') {
            setCandidateFile(file);
            setUploadResult({
                isProcessed: false,
                errors: [],
                createdCount: 0,
                rps: { success: 0, failed: 0, errors: [] }
            });
        }
    }
    const handlePhotoFileChange = ({ target }) => {
        const file = target?.files[0];
        if (file && mimes.ZIP.includes(file?.type)) {
            setPhotoFile(file);
            setUploadResult({
                isProcessed: false,
                errors: [],
                createdCount: 0,
                rps: { success: 0, failed: 0, errors: [] }
            });
        }
    }
    const handleSignFileChange = ({ target }) => {
        const file = target?.files[0];
        if (file && mimes.ZIP.includes(file?.type)) {
            setSignFile(file);
            setUploadResult({
                isProcessed: false,
                errors: [],
                createdCount: 0,
                rps: { success: 0, failed: 0, errors: [] }
            });
        }
    }
    const handleFileRemove = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.value = '';
            if (id === 'candidateFile') {
                setCandidateFile(null);
            } else if (id === 'photoFile') {
                setPhotoFile(null);
            } else if (id === 'signFile') {
                setSignFile(null);
            }
        }
    }
    const handleModalClose = () => {
        setUploadCandidateModalVisible(false);
        setCandidateFile(null);
        setUploadResult({
            isProcessed: false,
            createdCount: 0,
            errors: [],
            rps: { success: 0, failed: 0, errors: [] }
        })
        const candidateFileEle = document.getElementById('candidateFile');
        if (candidateFileEle) {
            candidateFileEle.value = '';
        }
    }
    const handleDownloadTemplate = async () => {
        try {
            const res = await downloadCandidateTemplate();
            const url = window.URL.createObjectURL(res);

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute(
                'download',
                `candidate-template.csv`,
            );
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            addNotification('File downloaded successfully.', 'success');
        } catch (error) {
            console.log('error', error);
            addNotification('Unexpected error occurred', 'danger');
        }
    }
    const handleUploadCandidate = async () => {
        if (uploadImages) {
            if (!projectMasterId || !candidateFile || !photoFile || !signFile) return;
            setIsUploading(true);
            try {
                const body = new FormData();
                body.append('candidateFile', candidateFile);
                body.append('photoFile', photoFile);
                body.append('signFile', signFile);
                const response = await uploadCandidate(projectMasterId, body);
                if (response.code === 'OK') {
                    if (response.data?.errors?.length) {
                        setUploadResult({
                            isProcessed: true,
                            createdCount: response.data.createdCount,
                            errors: response.data.errors,
                        });
                    } else if (response.data?.createdCount === 0) {
                        addNotification('Unexpected server error occurred.', 'danger');
                        handleModalClose();
                    } else {
                        addNotification('Candidates added successfully.', 'success');
                        setCandidatesChanged(!candidatesChanged);
                        handleModalClose();
                    }
                }
            } catch (error) {
                const code = error?.response?.data?.code;
                if (code === 'E_EXAM_ALREADY_ENABLED') {
                    addNotification('Exam enabled for selected master.', 'danger');
                } else {
                    addNotification('Unexpected error occurred.', 'danger');
                }
                console.log('There is an error while uploading bulk users', error);
            } finally {
                setIsUploading(false);
                handleFileRemove('candidateFile');
                handleFileRemove('photoFile');
                handleFileRemove('signFile');
            }
        } else {
            if (!candidateFile || !projectMasterId) return;
            setIsUploading(true);
            try {
                const body = new FormData();
                body.append('projectMasterId', projectMasterId);
                body.append('file', candidateFile);
                const response = await uploadProcessingCandidate(body);
                if (response.code === 'OK') {
                    const rps = response.data?.rps || { success: 0, failed: 0, errors: [] };
                    const hasCandidateErrors = response.data?.errors?.length > 0;
                    const hasRpsErrors = rps.failed > 0 || rps.errors?.length > 0;
                    if (hasCandidateErrors || hasRpsErrors) {
                        setUploadResult({
                            isProcessed: true,
                            createdCount: response.data.createdCount,
                            errors: response.data.errors || [],
                            rps,
                        });
                    } else if (response.data?.createdCount === 0) {
                        addNotification('Unexpected server error occurred.', 'danger');
                        handleModalClose();
                    } else {
                        addNotification('Candidates added successfully.', 'success');
                        setCandidatesChanged(!candidatesChanged);
                        handleModalClose();
                    }
                }
            } catch (error) {
                const code = error?.response?.data?.code;
                if (code === 'E_EXAM_ALREADY_ENABLED') {
                    addNotification('Exam enabled for selected master.', 'danger');
                } else {
                    addNotification('Unexpected error occurred.', 'danger');
                }
                console.log('There is an error while uploading bulk users', error);
            } finally {
                setIsUploading(false);
                handleFileRemove('candidateFile');
            }
        }
    }

    const renderStartIcon = () => {
        if (isUploading) {
            return <img src={UPLOAD_WHITE} alt='' />
        } else if (uploadImages) {
            if (candidateFile && photoFile && signFile) {
                return <img src={UPLOAD_WHITE} alt='' />
            } else {
                return <img src={UPLOAD_GREY} alt='' />
            }
        } else {
            if (candidateFile) {
                return <img src={UPLOAD_WHITE} alt='' />
            } else {
                return <img src={UPLOAD_GREY} alt='' />
            }
        }
    }

    const renderTableCell = (columnId, rowIndex) => {
        const row = uploadResult.errors[rowIndex];
        switch (columnId) {
            case 'index':
                return row['index']
            case 'rollNo':
                return row['rollNo']
            case 'userName':
                return row['userName']
            case 'errors':
                return <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                }}>
                    {row['errors'].map((err, index) => {
                        return <Typography key={index}>
                            {err}
                        </Typography>
                    })}

                </Box>
            default:
                return row[columnId];
        }
    }

    return (
        <Fragment>
            <Modal
                open={uploadCandidateModalVisible}
                onClose={handleModalClose}
                hideBackdrop={true}
                className='backdrop'
            >
                <Box className='modal-container' sx={{
                    maxWidth: 900,
                    p: 3
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 3,
                        gap: 1,
                    }}>
                        <Typography variant="h6" component="h6" sx={{
                            color: 'primary.main'
                        }}>
                            Upload Candidates
                        </Typography>
                        <RadiusButton
                            variant='outlined'
                            startIcon={<img src={DOWNLOAD_BLUE} alt='' />}
                            onClick={handleDownloadTemplate}
                        >
                            Download Template
                        </RadiusButton>
                    </Box>

                    <Box sx={{ mb: 2 }}>
                        <Box sx={{
                            overflow: 'auto',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            pb: 1
                        }}>
                            <RadiusButton
                                variant='contained'
                                component='label'
                                htmlFor='candidateFile'
                                color='secondary'
                                sx={{ flexShrink: 0 }}
                            >
                                Select Candidates File
                            </RadiusButton>
                            <input
                                style={{ display: 'none' }}
                                type='file'
                                id='candidateFile'
                                onChange={handleFileChange}
                                accept='text/csv'
                            />
                            {
                                candidateFile && candidateFile?.name && <Fragment>
                                    <Typography variant='subtitle1' >{candidateFile.name}</Typography>
                                    <img
                                        style={{ cursor: 'pointer' }}
                                        src={DELETE_ICON}
                                        onClick={() => handleFileRemove('candidateFile')}
                                        alt=''
                                    />
                                </Fragment>
                            }
                        </Box>
                    </Box>
                    {uploadImages
                        ? <>
                            <Box sx={{ mb: 2 }}>
                                <Box sx={{
                                    overflow: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    pb: 1
                                }}>
                                    <RadiusButton
                                        variant='contained'
                                        component='label'
                                        htmlFor='photoFile'
                                        color='secondary'
                                        sx={{ flexShrink: 0 }}
                                    >Select Photo File</RadiusButton>
                                    <input
                                        style={{ display: 'none' }}
                                        type='file'
                                        id='photoFile'
                                        onChange={handlePhotoFileChange}
                                        accept={mimes.ZIP}
                                    />
                                    {
                                        photoFile && photoFile?.name && <Fragment>
                                            <Typography variant='subtitle1' >{photoFile.name}</Typography>
                                            <img
                                                style={{ cursor: 'pointer' }}
                                                src={DELETE_ICON}
                                                onClick={() => handleFileRemove('photoFile')}
                                                alt=''
                                            />
                                        </Fragment>
                                    }
                                </Box>
                            </Box>
                            <Box sx={{ mb: 2 }}>
                                <Box sx={{
                                    overflow: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    pb: 1
                                }}>
                                    <RadiusButton
                                        variant='contained'
                                        component='label'
                                        htmlFor='signFile'
                                        color='secondary'
                                        sx={{ flexShrink: 0 }}
                                    >Select Signature File</RadiusButton>
                                    <input
                                        style={{ display: 'none' }}
                                        type='file'
                                        id='signFile'
                                        onChange={handleSignFileChange}
                                        accept={mimes.ZIP}
                                    />
                                    {
                                        signFile && signFile?.name && <Fragment>
                                            <Typography variant='subtitle1' >{signFile.name}</Typography>
                                            <img
                                                style={{ cursor: 'pointer' }}
                                                src={DELETE_ICON}
                                                onClick={() => handleFileRemove('signFile')}
                                                alt=''
                                            />
                                        </Fragment>
                                    }
                                </Box>
                            </Box>
                        </>
                        : null}
                    <FormControlLabel
                        control={
                            <Checkbox
                                size='small'
                                checked={uploadImages}
                                disabled = {true}
                                onChange={() => setUploadImages(!uploadImages)}
                            />
                        }
                        sx={{
                            maxWidth: 400,
                            '& .MuiTypography-root': {
                                color: 'primary.main',
                                fontSize: 13,
                            }
                        }}
                        label="Also upload photo and signature images"
                    />
                    {uploadResult.isProcessed && <>
                        <Typography sx={{ fontSize: 17, mb: 2 }}>Successfully created records count: {uploadResult.createdCount}</Typography>
                        {uploadResult.errors?.length ? <>
                            <Typography sx={{ fontSize: 17, mb: 1 }}>Errors: </Typography>
                            <Paper sx={{
                                width: '100%',
                                overflow: 'hidden',
                                bgcolor: 'background.base',
                                maxHeight: 250,
                                borderRadius: 1,
                                mb: 4
                            }}>
                                <TableContainer sx={{
                                    px: 1,
                                    pb: 1,
                                    maxHeight: 'inherit',
                                    maxWidth: 'inherit',
                                    border: '1px solid',
                                    borderColor: 'primary.main',
                                    borderRadius: 1
                                }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column) => (
                                                    <TableCell
                                                        sx={{
                                                            color: 'primary.main',
                                                            p: 1,
                                                        }}
                                                        key={column.id}
                                                        align='center'
                                                        style={{ minWidth: column.minWidth }}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {!uploadResult?.errors?.length
                                                ? <TableRow sx={{ mx: 'auto', p: 2, color: 'grey.500' }}>
                                                    <TableCell colSpan={7} sx={{ border: 'none', textAlign: 'center' }}>
                                                        No records available
                                                    </TableCell>
                                                </TableRow>
                                                : uploadResult.errors.map((row, rowIndex) => {
                                                    return (
                                                        <TableRow hover={false} role="checkbox" key={rowIndex}>
                                                            {columns.map((column) => {
                                                                return <TableCell key={column.id} align='center' sx={{
                                                                    px: 1.5,
                                                                    py: 0.75
                                                                }}>
                                                                    {renderTableCell(column.id, rowIndex)}
                                                                </TableCell>
                                                            })}
                                                        </TableRow>
                                                    );
                                                })
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </> : null}
                        {(uploadResult.rps?.failed > 0 || uploadResult.rps?.errors?.length > 0) ? <>
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                mb: uploadResult.rps.errors?.length ? 1.5 : 4,
                            }}>
                                <Typography sx={{ fontSize: 17 }}>RPS Upload Status:</Typography>
                                <Chip
                                    size='small'
                                    label={`${Number(uploadResult.rps.success) || 0} Succeeded`}
                                    sx={{ bgcolor: 'success.main', color: '#fff', fontWeight: 600, fontSize: 12 }}
                                />
                                <Chip
                                    size='small'
                                    label={`${Number(uploadResult.rps.failed) || 0} Failed`}
                                    sx={{ bgcolor: 'error.main', color: '#fff', fontWeight: 600, fontSize: 12 }}
                                />
                            </Box>
                            {uploadResult.rps.errors?.length ? <Paper sx={{
                                width: '100%',
                                overflow: 'hidden',
                                bgcolor: 'background.base',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'error.100',
                                mb: 4,
                            }}>
                                <Box sx={{ px: 2, py: 1, bgcolor: 'error.100' }}>
                                    <Typography sx={{
                                        fontSize: 12,
                                        fontWeight: 700,
                                        color: 'error.main',
                                        textTransform: 'uppercase',
                                        letterSpacing: 0.4,
                                    }}>
                                        RPS Errors ({uploadResult.rps.errors.length})
                                    </Typography>
                                </Box>
                                <Box sx={{ overflow: 'auto', maxHeight: 190 }}>
                                    {uploadResult.rps.errors.map((err, index) => (
                                        <Box key={index} sx={{
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            gap: 1.25,
                                            px: 2,
                                            py: 1,
                                            borderTop: index === 0 ? 'none' : '1px solid',
                                            borderColor: 'background.default',
                                        }}>
                                            <Box sx={{
                                                flexShrink: 0,
                                                width: 20,
                                                height: 20,
                                                mt: 0.15,
                                                borderRadius: '50%',
                                                bgcolor: 'error.100',
                                                color: 'error.main',
                                                fontSize: 11,
                                                fontWeight: 700,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            }}>
                                                {index + 1}
                                            </Box>
                                            <Typography sx={{ fontSize: 14, color: 'text.primary' }}>
                                                {err}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            </Paper> : null}
                        </> : null}
                    </>}

                    <Box className='actions-container'>
                        <RadiusButton
                            variant='contained'
                            color='grey'
                            sx={{ ml: 'auto' }}
                            onClick={handleModalClose}
                            disabled={isUploading}
                        >
                            Cancel
                        </RadiusButton>
                        <LoadingButton
                            sx={{
                                borderRadius: '46px',
                                textTransform: 'none'
                            }}
                            variant='contained'
                            onClick={handleUploadCandidate}
                            disabled={!canEditLockedConfig || (isUploading ? isUploading : uploadImages ? !candidateFile || !photoFile || !signFile : !candidateFile)}
                            loading={isUploading}
                            loadingPosition="start"
                            startIcon={renderStartIcon()}
                        >
                            Upload
                        </LoadingButton>
                    </Box>

                </Box>
            </Modal>
        </Fragment>
    );
}
